<table class="table table-sm variance-table align-middle"
       [attr.data-testid]="testId">
    <caption class="visually-hidden">Per-station-run total, first-pass, and rework labor with dwell and standard effectiveness for this batch</caption>
    <thead>
        <tr>
            <th scope="col" class="expander-col"><span class="visually-hidden">Expand</span></th>
            <th scope="col">Station</th>
            <th scope="col" class="numeric">{{ showsReworkBreakdown ? 'Total labor' : 'Labor' }}</th>
            <th *ngIf="showsReworkBreakdown" scope="col" class="numeric touch-split-col">First-pass</th>
            <th *ngIf="showsReworkBreakdown" scope="col" class="numeric touch-split-col">Rework</th>
            <th scope="col" class="numeric">Dwell</th>
            <th scope="col" class="numeric">Standard</th>
            <th scope="col" class="bar-col">Labor vs Standard</th>
            <th scope="col" class="numeric variance-col">Effectiveness</th>
            <th scope="col">Operators</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let s of rows">
            <tr [attr.data-station-id]="s.station_id" class="variance-summary-row">
                <td class="expander-col">
                    <app-row-expander
                        [expanded]="isExpanded(s)"
                        [controlsId]="entriesRowId(s)"
                        testId="variance-row-expander"
                        [expandLabel]="'Expand entries for ' + (s.station_name || 'unassigned')"
                        [collapseLabel]="'Collapse entries for ' + (s.station_name || 'unassigned')"
                        (toggled)="onToggle(s)">
                    </app-row-expander>
                </td>
                <td class="station-name">{{ s.station_name || '—' }}</td>
                <td class="numeric" data-testid="variance-station-total-touch">
                    {{ showsReworkBreakdown ? formatMinutesHM(s.touch_minutes) : formatMinutes(s.touch_minutes) }}
                </td>
                <td *ngIf="showsReworkBreakdown"
                    class="numeric touch-split-col"
                    data-testid="variance-station-first-pass">
                    {{ formatMinutesHM(s.first_pass_touch_minutes) }}
                </td>
                <td *ngIf="showsReworkBreakdown"
                    class="numeric touch-split-col rework-touch"
                    data-testid="variance-station-rework">
                    {{ formatMinutesHM(s.rework_touch_minutes) }}
                </td>
                <td class="numeric">{{ formatMinutes(s.dwell_minutes) }}</td>
                <td class="numeric">{{ formatMinutes(s.standard_minutes) }}</td>
                <td class="bar-col">
                    <ng-container *ngIf="s.standard_minutes; else noBar">
                        <div class="touch-bar-track"
                             data-testid="touch-bar-track"
                             [attr.data-touch-minutes]="s.touch_minutes"
                             [attr.data-standard-minutes]="s.standard_minutes"
                             [attr.data-standard-pct]="touchBarLayout(s).markerPct"
                             [title]="'Labor ' + formatMinutes(s.touch_minutes) + ' · standard ' + formatMinutes(s.standard_minutes)">
                            <div class="touch-bar-fill"
                                 data-testid="touch-bar-fill"
                                 [class]="varianceClass(s.variance_ratio)"
                                 [style.width.%]="touchBarLayout(s).fillPct"
                                 [attr.data-fill-pct]="touchBarLayout(s).fillPct">
                            </div>
                            <div class="touch-bar-standard-marker"
                                 data-testid="touch-bar-standard-marker"
                                 [style.left.%]="touchBarLayout(s).markerPct">
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noBar>
                        <span class="text-muted">no standard</span>
                    </ng-template>
                </td>
                <td class="numeric variance-col" [ngClass]="varianceClass(s.variance_ratio)">
                    <app-variance-pill [ratio]="s.variance_ratio"></app-variance-pill>
                </td>
                <td class="operators">
                    <ng-container *ngFor="let op of s.operators; let last = last">
                        <ng-container *ngIf="operatorLink(op.user_id) as link; else opPlain">
                            <a class="operator-link" [routerLink]="link">{{ op.name || '—' }}</a>
                        </ng-container>
                        <ng-template #opPlain>
                            <span>{{ op.name || '—' }}</span>
                        </ng-template>
                        <ng-container *ngIf="!last">, </ng-container>
                    </ng-container>
                    <span *ngIf="!s.operators?.length" class="text-muted">—</span>
                </td>
            </tr>
            <tr class="variance-entries-row"
                [id]="entriesRowId(s)"
                [hidden]="!isExpanded(s)">
                <td [attr.colspan]="columnCount">
                    <ul class="station-entries"
                        data-testid="variance-row-entries"
                        *ngIf="entriesFor(s).length; else noEntries">
                        <li *ngFor="let e of entriesFor(s)"
                            class="station-entry-row"
                            data-testid="variance-entry-row"
                            [attr.data-entry-id]="e.time_entry_id">
                            <span class="entry-operator">
                                <ng-container *ngIf="operatorLink(e.user_id) as link; else anonOp">
                                    <a [routerLink]="link" class="operator-link">{{ e.user_name || '—' }}</a>
                                </ng-container>
                                <ng-template #anonOp>{{ e.user_name || '—' }}</ng-template>
                            </span>
                            <span class="entry-stamp">
                                {{ e.start_ts | date:'short' }}<span *ngIf="e.end_ts"> → {{ e.end_ts | date:'shortTime' }}</span>
                            </span>
                            <span class="entry-duration">
                                {{ e.is_rework ? formatMinutesHM(e.duration_minutes) : (e.durationLabel || formatMinutes(e.duration_minutes)) }}
                            </span>
                            <span class="entry-statuses">
                                <span
                                    *ngIf="e.is_rework != null"
                                    class="badge"
                                    data-testid="variance-entry-work-type"
                                    [ngClass]="e.is_rework ? 'bg-warning text-dark' : 'bg-secondary text-white'">
                                    {{ e.is_rework ? 'Rework' : 'Standard work' }}
                                </span>
                                <span *ngIf="e.is_open" class="badge bg-info text-white">in progress</span>
                            </span>
                            <span class="entry-actions">
                                <button type="button"
                                        class="btn btn-sm btn-outline-secondary"
                                        data-testid="variance-entry-edit"
                                        (click)="onEntryEdit(e)">
                                    <i class="fa fa-pencil"></i> Edit
                                </button>
                            </span>
                        </li>
                    </ul>
                    <ng-template #noEntries>
                        <div class="text-muted text-center py-2">No entries recorded for this station.</div>
                    </ng-template>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>
